
import { map } from 'rxjs/operators';
import { httpClient } from "../shop/shop-context";
import { Observable } from 'rxjs';
import { PasswordForgotModel } from '../models/passwordforgot';
import { HttpResponse } from '../httpclient/httpclient';

export class ForgotPasswordService {
	private _url = 'connect/account';

	sendCode(model: PasswordForgotModel): Observable<boolean> {
		const url = `/${this._url}/forgot-password`;
		// responseType: 'text' is for IE otherwise it tries to parse it and throws an error?!
		return httpClient
			.post<HttpResponse<string>>(url, model,true)
			.pipe(map(response => response.ok));
	}

	verifyCode(username: string, code: string): Observable<boolean> {
		const url = `/${this._url}/forgot-password/${username}/verify/${code}`;

		return httpClient.get<boolean>(url);
	}

	changePassword(model: PasswordForgotModel): Observable<boolean> {
		const url = `/${this._url}/change-password`;

		// responseType: 'text' is for IE otherwise it tries to parse it and throws an error?!
		return httpClient
			.put<HttpResponse<string>>(url, model,true)
			.pipe(map(response => response.ok));
	}
}
